export enum JobTitle {
  AGENTE = 'AGENTE',
  AREA_MANAGER = 'AREA_MANAGER',
  BROKER = 'BROKER',
  CONSULENTE = 'CONSULENTE',
  EXECUTIVE = 'EXECUTIVE',
  TEAM_LEADER = 'TEAM_LEADER',
}
